import { getSubjectPlan } from "@twinkltech/curriculum-architect-domain-hooks";

import {
  initialState,
  TableData,
} from "@/states/unitTableReducer/unitTableReducer";
import { sortResourcesByKeyStage } from "@/utils/sortResourcesByKeyStage/sortResourcesByKeyStage";

export const mapApiDataToTableReducer = (
  data: getSubjectPlan | null
): Omit<TableData, "isLoading"> => {
  return data
    ? {
        version: data.plan.version,
        isModified: false,
        columns: data.plan.value.columns.map((column) => ({
          id: column.columnId,
          title: column.displayLabel,
          slug: column.slug,
          order: column.order,
        })),
        rows: data.plan.value.rows.map((row) => ({
          id: row.rowId,
          title: row.displayLabel,
          slug: row.slug,
          order: row.order,
          keyStages: row.attributes.keyStages,
        })),
        cells:
          data.plan.value.cells?.map((cell) =>
            "isCustom" in cell
              ? {
                  id: cell.cellId,
                  isCustom: true,
                  title: cell.title,
                  description: cell.description,
                  column: cell.columnId,
                  row: cell.rowId,
                  span: cell.span,
                }
              : {
                  id: cell.cellId,
                  resourceId: cell.resourceId,
                  column: cell.columnId,
                  row: cell.rowId,
                  span: cell.span,
                  adaptationNote: cell.adaptationNote,
                }
          ) || [],
        resources: sortResourcesByKeyStage(
          data?.resources?.map((resource) => ({
            id: resource.resourceId,
            name: resource.title,
            imageUrl: resource.keyArtUrl || "",
            keyStagesSlug: resource.keyStagesSlug,
            threadSlugs: resource.threadSlugs,
          })) ?? []
        ),
      }
    : initialState.present;
};
